import React from 'react';
const bonuses = [{
  title: 'DANCE READY™ Ultimate Class Themes Book',
  description: '50 themed class ideas ready to use so you never run out of creative direction again.'
}, {
  title: 'DANCE READY™ 100 Class Starters & Warm-Up Systems',
  description: 'Ready-to-use warm-ups and class openers for every level, energy and class goal.'
}, {
  title: 'DANCE READY™ Cueing & Correction Handbook',
  description: 'The precise phrases to guide, correct and sound like an expert in every single class.'
}, {
  title: 'DANCE READY™ Content & Promotion Kit',
  description: 'Simple tools to promote your classes and attract more students without spending hours on marketing.'
}, {
  title: 'DANCE READY™ Studio-Friendly Printable Planning Pack',
  description: 'Your complete set of printable worksheets, trackers and planning pages for daily studio use.'
}];
const benefits = [{
  emoji: '⚡',
  title: 'Mental Load Liberation',
  desc: 'Open the system, select the class structure that matches your group, and teach. The planning is already done for you.'
}, {
  emoji: '👑',
  title: 'Authority and Confidence',
  desc: "Walk into the studio with an expert's presence and the right words to guide, correct and inspire your students at every level."
}, {
  emoji: '🎶',
  title: 'True Student Progression',
  desc: 'Pedagogically structured sequences so your students feel real improvement — and keep coming back week after week.'
}, {
  emoji: '😌',
  title: 'Zero Transition Stress',
  desc: 'Master the art of fluid class transitions and energy management for a seamless class experience that will impress every student in the room.'
}];
export function BonusSection() {
  return <>
      <section className="py-6 px-4 sm:px-6 bg-brand-cream" data-id="element-15">
        <div className="text-center mb-4" data-id="element-16">
          <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-taupe mb-1 uppercase leading-tight" data-id="element-17">
            5 LUXURY BONUSES INCLUDED
          </h2>
          <p className="text-sm sm:text-base font-subheading font-bold text-brand-rose mb-1" data-id="element-18">
            Plus, you'll receive 5 luxury bonuses
          </p>
          <p className="text-sm text-brand-taupe font-medium leading-tight" data-id="element-19">
            Exclusive resources that will transform your day-to-day — included
            FREE with your pack.
          </p>
        </div>

        <div className="flex flex-col gap-2 mb-4" data-id="element-20">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white border-2 border-brand-gold/40 p-3 rounded text-center shadow-sm" data-id="element-21">
              <p className="text-[11px] font-button font-bold text-brand-gold mb-0.5 tracking-wider uppercase" data-id="element-22">
                🎁 BONUS {i + 1} — FREE
              </p>
              <h3 className="text-sm font-bold text-brand-taupe mb-1 leading-tight" data-id="element-23">
                {bonus.title}
              </h3>
              <p className="text-xs text-brand-taupe/80 font-medium leading-tight" data-id="element-24">
                {bonus.description}
              </p>
            </div>)}
        </div>

        <p className="text-center font-button font-bold text-brand-rose text-sm uppercase tracking-wide bg-brand-rose/10 py-2 rounded" data-id="element-25">
          The 5 bonuses are FREE with your purchase today.
        </p>
      </section>

      <section className="py-6 px-4 sm:px-6 bg-white border-t-4 border-brand-beige" data-id="element-26">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-center text-brand-taupe mb-1 uppercase leading-tight" data-id="element-27">
          WHAT IS GOING TO CHANGE
        </h2>
        <p className="text-sm sm:text-base font-subheading font-bold text-center text-brand-rose mb-1" data-id="element-28">
          What will change in your professional life
        </p>
        <p className="text-sm text-center text-brand-taupe mb-4 font-bold" data-id="element-29">
          Real benefits starting from the first week:
        </p>

        <div className="flex flex-col gap-2" data-id="element-30">
          {benefits.map((item, i) => <div key={i} className="bg-brand-cream border-l-4 border-brand-rose p-3 rounded-r shadow-sm flex gap-3 items-start" data-id="element-31">
              <div className="text-xl shrink-0 leading-none" data-id="element-32">{item.emoji}</div>
              <div data-id="element-33">
                <h3 className="text-sm font-bold text-brand-taupe mb-0.5 uppercase tracking-tight" data-id="element-34">
                  {item.title}
                </h3>
                <p className="text-brand-taupe/80 text-xs font-medium leading-tight" data-id="element-35">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </section>
    </>;
}